module.exports = __webpack_public_path__ + "43b45e97733773f7f146b6f6fadba85b.svg";


//////////////////
// WEBPACK FOOTER
// ./components/zynappse-crud/assets/images/ic_add_image.svg
// module id = 1083
// module chunks = 0